import React, { useContext } from 'react';
import styled from 'styled-components';
import { ThemeContext } from 'context/themeContext';
import MainContext from 'MainContext';

const ProfileName = styled.div`
  position: relative;
  margin-top:1vw;
  height: 2.0864vw;
  width: 100%;
  font-size: 1vw;
  padding-left: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  padding-right: ${(props) => (props.rtlDirection ? '1.56vw' : 'unset')};
  font-weight: 600;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.textSecondary};
  transition: 200ms linear;
`;
const ProfileEmail = styled.div`
  position: relative;
  height: 1.0864vw;
  width: 100%;
  font-size: 0.8vw;
  padding-left: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  padding-right: ${(props) => (props.rtlDirection ? '1.56vw' : 'unset')};
  font-weight: 300;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.textSecondary};
  transition: 200ms linear;
`;

const App = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { profile } = useContext(MainContext).login;

  return (
    <>
      <ProfileName rtlDirection={rtlDirection} theme={theme} display={props.selectedTab === props.link}>
        {profile.first_name + ' ' + profile.last_name}
      </ProfileName>
      <ProfileEmail rtlDirection={rtlDirection} theme={theme} display={props.selectedTab === props.link} sty>
        {profile.cellphone}
      </ProfileEmail>
    </>
  );
};

export default App;
